<script lang="ts" setup>
import type { PromoCta } from '#core/types'

const items = [
  'KPI adherence',
  'Liquidity and volume',
  'Impact across markets',
]

const ctas: PromoCta[] = [
  { label: 'Start Monitoring', to: '/market-maker-monitoring' },
  { label: 'Watch the 2-Minute Demo', variant: 'outline', icon: 'play', videoUrl: 'https://www.youtube.com/watch?v=NC3ae-FhVw8' },
]
</script>

<template>
  <CorePromoBanner
    intro="Link your existing market makers, or engage with new ones, and start tracking:"
    :items="items"
    :ctas="ctas"
    image="/images/home/promo-monitoring.webp"
    image-class="object-contain object-right"
  >
    <template #heading>
      <span class="text-accent">Fully transparent monitoring</span> of your liquidity providers
    </template>
  </CorePromoBanner>
</template>
